import { MasterEvent } from "../../models/MasterEvent";
import { MarketParser } from "../MarketParser";
import { ParseDate } from "../../helpers/ParseDate";
import { OddsHelper } from "../../helpers/Odds/Odds";
import { LiveEventsTime, LiveMasterEventLegacy, EventLiveLegacy } from "sb-resp-lib";
import { TennisScoreParser } from "../TennisScoreParser";
import { Market, TennisScore } from "../../models";
import { PreLiveMasterEventLegacy, EventPreliveLegacy } from "../../../../../interfaces";

export class MasterEventParser {

    public static ParseLive(liveMasterEvent: LiveMasterEventLegacy, liveEventsTime: LiveEventsTime, oddsUtil: Odds, gameStatusProvider: GameStatus): MasterEvent {
        let markets: Market[] = MasterEventParser.parseMarkets(liveMasterEvent.MultiViewRegularEvents);
        markets = markets.concat(MasterEventParser.parseMarkets(liveMasterEvent.MultiViewQAEvents));

        let liveTimeElapsed = liveEventsTime.getTime(liveMasterEvent.GameData, parseInt(liveMasterEvent.BranchID));
        OddsHelper.convertMarketOdds(markets, oddsUtil, liveMasterEvent.BranchID);

        let tennisData = TennisScoreParser.parseData(liveMasterEvent.Score1.toString(), liveMasterEvent.Score2.toString());

        return new MasterEvent({
            id: liveMasterEvent.ID.toString(),
            branchID: liveMasterEvent.BranchID.toString(),
            branchName: liveMasterEvent.BranchName,
            isLive: true,
            markets,
            isTeamSwapEnabled: liveMasterEvent.IsTeamSwapEnabled,
            leagueID: liveMasterEvent.LeagueID.toString(),
            leagueName: liveMasterEvent.LeagueName,
            eventDate: liveMasterEvent.MasterEventDate.formatDate("dd/MM/yy"),
            eventTime: liveMasterEvent.MasterEventDate.formatDate("hh:mm"),
            liveTimeElapsed,
            team1Name: liveMasterEvent.Team1Name,
            team2Name: liveMasterEvent.Team2Name,
            score1: liveMasterEvent.Score1 ? liveMasterEvent.Score1 : "",
            score2: liveMasterEvent.Score2 ? liveMasterEvent.Score2 : "",
            allMarketsCount: liveMasterEvent.QACount * 1,
            hasFastMarketsSpecials: liveMasterEvent.HasFastMarketsSpecials,
            hasLiveStream: liveMasterEvent.hasLiveStream,
            danger: liveMasterEvent.Danger,
            link: liveMasterEvent.Link,
            additionalData: liveMasterEvent.AdditionalData,
            gameData: liveMasterEvent.GameData,
            masterEventDate: liveMasterEvent.MasterEventDate,
            tennisData,
            gameStatusProvider,

        });
    }

    public static ParsePreLive(preLiveMasterEvent: PreLiveMasterEventLegacy, oddsUtil: Odds, timeZone: number): MasterEvent {
        let markets: Market[] = MasterEventParser.parseMarkets(preLiveMasterEvent.MultiViewRegularEvents);
        markets = markets.concat(MasterEventParser.parseMarkets(preLiveMasterEvent.MultiViewQAEvents));

        OddsHelper.convertMarketOdds(markets, oddsUtil, preLiveMasterEvent.BranchID);

        return new MasterEvent({
            id: preLiveMasterEvent.ID.toString(),
            branchID: preLiveMasterEvent.BranchID.toString(),
            branchName: preLiveMasterEvent.BranchName,
            isLive: false,
            markets,
            isTeamSwapEnabled: false,
            leagueID: preLiveMasterEvent.LeagueID.toString(),
            leagueName: preLiveMasterEvent.LeagueName,
            eventDate: ParseDate(preLiveMasterEvent.MasterEventDate, timeZone).formatDate("dd/MM/yy"),
            eventTime: ParseDate(preLiveMasterEvent.MasterEventDate, timeZone).formatDate("HH:mm"),
            liveTimeElapsed: 0,
            team1Name: preLiveMasterEvent.Team1Name,
            team2Name: preLiveMasterEvent.Team2Name,
            allMarketsCount: preLiveMasterEvent.Specials * 1,
            hasFastMarketsSpecials: false,
            hasLiveStream: preLiveMasterEvent.hasLiveStream,
            danger: preLiveMasterEvent.Danger,
            link: preLiveMasterEvent.Link,
            masterEventDate: preLiveMasterEvent.MasterEventDate,
            score1: "",
            score2: "",
            gameData: "",
            tennisData: TennisScore.createEmptyTennisScore()
        });
    }

    private static parseMarkets(multiViewEvents: EventPreliveLegacy[] | EventLiveLegacy[]): Market[] {
        let markets: Market[] = [];

        for (let index = 0; index < Object.keys(multiViewEvents).length; index += 1) {
            markets = markets.concat(MarketParser.ParseEvent(multiViewEvents[Object.keys(multiViewEvents)[index]]))
        }

        return markets;
    }
}
